import React from 'react';
import PropTypes from 'prop-types';
import useMobileLayout from 'Hooks/useMobileLayout';
import MobileTimelineItem from 'Components/ComponentLibrary/Organisms/Timeline/MobileTimelineItem';
import DesktopTimelineItem from 'Components/ComponentLibrary/Organisms/Timeline/DesktopTimelineItem';

export default function TimelineItemPicker({
  itemResource, month, timelineCardComponent, isFirstItem, isLastItem,
}) {
  const isMobile = useMobileLayout();

  if (isMobile) {
    return <MobileTimelineItem itemResource={itemResource} month={month} timelineCardComponent={timelineCardComponent} isFirstItem={isFirstItem} isLastItem={isLastItem} />;
  }

  return <DesktopTimelineItem itemResource={itemResource} month={month} timelineCardComponent={timelineCardComponent} isFirstItem={isFirstItem} isLastItem={isLastItem} />;
}

TimelineItemPicker.defaultProps = {
  month: '',
  isFirstItem: false,
  isLastItem: false,
};

TimelineItemPicker.propTypes = {
  itemResource: PropTypes.object.isRequired,
  month: PropTypes.string,
  timelineCardComponent: PropTypes.element.isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
};
